import Phaser from 'phaser';
import { CONFIG } from '../config.js';

export class SplashScene extends Phaser.Scene {
  constructor() {
    super({ key: 'SplashScene' });
  }

  create() {
    const { width, height } = this.scale;
    this.cameras.main.setBackgroundColor('#0f0d2c');

    let logoNode;
    if (this.textures.exists('pixie-logo')) {
      const tex = this.textures.get('pixie-logo').getSourceImage();
      const targetW = Math.min(width * 0.85, 380);
      const scale = targetW / tex.width;
      logoNode = this.add
        .image(width / 2, height / 2, 'pixie-logo')
        .setOrigin(0.5)
        .setScale(scale)
        .setAlpha(0);
    } else {
      // Text fallback if the logo image failed to load.
      logoNode = this.add
        .text(width / 2, height / 2, 'PIXIE\nSTUDIOS', {
          fontFamily: '"Press Start 2P", monospace',
          fontSize: '36px',
          color: '#d946ef',
          align: 'center',
          lineSpacing: 10,
        })
        .setOrigin(0.5)
        .setAlpha(0);
    }

    this.tweens.add({
      targets: logoNode,
      alpha: { from: 0, to: 1 },
      duration: 400,
      onComplete: () => {
        this.tweens.add({
          targets: logoNode,
          alpha: 0,
          delay: 700,
          duration: 400,
          onComplete: () => this.scene.start('MenuScene'),
        });
      },
    });

    // Tap-to-skip for impatient kids.
    this.input.once('pointerdown', () => {
      this.tweens.killAll();
      this.scene.start('MenuScene');
    });
  }
}
